import { render, staticRenderFns } from "./TeamIdentification.vue?vue&type=template&id=05b215ed&"
import script from "./TeamIdentification.vue?vue&type=script&lang=js&"
export * from "./TeamIdentification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports